import React, {useEffect, useRef, useState} from 'react'
import axios from 'axios'
import { v4 as uuid } from 'uuid'
import NumberFormat from 'react-number-format';
import Parser from 'html-react-parser';


// Mol
import CPlanAccordion from '../../../Molecules/Cards/Plan/CPlanAccordion'

//Libraries
import Slider from "react-slick"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const PaquetesMiNegocio = () => {

	const [dataCPlanes, setdataCPlanes] = useState([])
	const [pageCount, setPageCount] = useState(1)
	const [offset, setOffset] = useState(0)
	const [perPage, setPerPage] = useState(6)

	const [keysPlanCompare, setKeysPlanCompare] = useState([])
    const [rangePriceState, setRangePriceState] = useState({})
	


    async function getMinMaxPrice(dataArray = null) {
        // console.log("Calculate range price min and max***********", dataArray)
        if (!dataArray?.length) {
            console.log("Calculate range price min and max if ***********", dataArray)
            // return { min: 0, max: 20000 }
            await setRangePriceState({ min: 0, max: 20000 })
        } else {
            // console.log("Calculate range price min and max else***********", dataArray)
            dataArray.sort(function (a, b) {
                return a.fi_PRECIO_PLAN - b.fi_PRECIO_PLAN
            })
            let min = dataArray[0].fi_PRECIO_PLAN;
            let max = dataArray[dataArray.length - 1].fi_PRECIO_PLAN;
            console.log("Calculate range price min and max___________________________________", min, max)
            if(max <= 0){
                setShowRangPrice(false)
            }
            await setRangePriceState({ min: min, max: max > 0 ? max : 100 })
        }
    }

    
	useEffect(() => {
        getCPlanes();
        // eslint-disable-next-line
    }, [])

	async function getCPlanes() {
        console.log("dataCPlanes********************************+")
        let url_servicio_web = localStorage.getItem('url_servicio_web')
        let id_familia = localStorage.getItem('id_familia')
        const configCPlanes = {
            method: 'GET',
            url: url_servicio_web + "get_cplanes?fi_familia=" + id_familia,
            data: {},
            headers: {
                'Accept': "application/json",
                'Content-Type': "application/json"
            },
        };
        let response = await axios(configCPlanes)
        console.log("response- getCPlanes------------------------->", response);
        let pageCountVal = response.data ? (Math.ceil(response.data.length )) : 1;
        await setdataCPlanes(response.data)
       // await setdataCPlanesBk(response.data)
        //await setdataCPlanesBkHead(response.data)
       getMinMaxPrice(response.data)

        setPageCount(pageCountVal)
        //setPerPage(6)
    }

	const handleChangeCompare = (el) => {
        let isCheck = el.target.checked
		console.log("curiosidad", isCheck)
        let planId = parseInt(el.target.name)
        console.log("handleChangeCompare isCheck: " + isCheck, "planId:" + planId);
        if (isCheck) {
            const exist = keysPlanCompare.filter((id) => id === planId);
            if (!exist.length) {
                setKeysPlanCompare([...keysPlanCompare, planId])
            }
        } else {
            let newarray = keysPlanCompare.filter(element => element !== planId);
            setKeysPlanCompare(newarray)
        }
    }

		
    const settingsSliderPlanes = {
		infinite: false,
        autoplay: false,
        speed: 800,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
		centerMode: false,
        responsive: [{
			breakpoint: 640,
			settings: {
				slidesToShow: 1,
				arrows: false,
			}
		},{
			breakpoint: 960,
			settings: {
				slidesToShow: 2,
				arrows: true,
			}
		},{
			breakpoint: 1200,
			settings: {
				slidesToShow: 3,
			}
		}]
    }

	const settingsMiNegocioSliderFull  = {
        infinite: false,
        autoplay: false,
        speed: 800,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
		centerMode: false,
        responsive: [{
			breakpoint: 640,
			settings: {
				slidesToShow: 1,
				arrows: false,
			}
		},{
			breakpoint: 960,
			settings: {
				slidesToShow: 2,
				arrows: true,
			}
		},{
			breakpoint: 1200,
			settings: {
				slidesToShow: 3,
			}
		}]
    }


	const [tabs] = useState([
		{
			title: '6 meses',
		},
		{

			title: '12 meses',
		}
	])

	function calculateInitElementShow() {
        const result = offset * perPage
        return result
    }

    function calculateFnElementShow() {
        return calculateInitElementShow() +perPage 
    }

	const [tabMobilOpen, setTabMobilOpen] = useState(false)
	const [tabSelected, setTabSelected] = useState(tabs[0])

	const _renderTabs = (caracteristicas) =>(
		caracteristicas &&
			caracteristicas.map((caracteristicas, index)=>
				<li
					key={index}
					onClick={()=>{setTabSelected(caracteristicas);setTabMobilOpen(false)}}
				>
					<a className={tabSelected.title === caracteristicas.title ? 'active': ''} href='#!'>
						{caracteristicas.title}
					</a>
				</li>
			)
	)
	const PlayPLanData = dataCPlanes.length ? dataCPlanes.slice(calculateInitElementShow(), calculateFnElementShow()).map((item, index) => (    
		<div key={uuid()} className="wrappCPlanAccordionSlider">
            <CPlanAccordion
                key={uuid()}
                title={item.fc_TEXTO_CAJA.trimEnd()}
                titlestyle={item.fc_COLOR_CAJA ? item.fc_COLOR_CAJA.toLowerCase() : null}
                name={item.fc_NOMBRE.trimEnd()}
                changeCompare={handleChangeCompare}
                fi_PLAN={item.fi_PLAN}
                fi_ID_TELEFONIA={item.fi_ID_TELEFONIA}
                fi_ID_TELEVISION={item.fi_ID_TELEVISION}
                fi_ID_INTERNET={item.fi_ID_INTERNET}
                fi_CATEGORIA={item.fi_CATEGORIA}
                fc_TIPO_DISPONIBILIDAD={item.fc_TIPO_DISPONIBILIDAD}
                fc_TEXTO_CAJA={item.fc_TEXTO_CAJA}
                fc_COLOR_CAJA={item.fc_COLOR_CAJA}
                fc_NOMBRE={item.fc_NOMBRE}
                fc_DESCRIPCION={item.fc_DESCRIPCION}
                fi_NUMERO_CARACTERISTICAS_MOSTRAR={item.fi_NUMERO_CARACTERISTICAS_MOSTRAR}
                fc_TITULO_CARACTERISTICAS_AGRUPADAS={item.fc_TITULO_CARACTERISTICAS_AGRUPADAS}
                fi_PRECIO_PLAN={item.fi_PRECIO_PLAN > 0 ? <NumberFormat thousandSeparator={","} decimalSeparator={"."} displayType={'text'} value={Number.isInteger(item.fi_PRECIO_PLAN)  ? item.fi_PRECIO_PLAN : item.fi_PRECIO_PLAN.toFixed(2)} />: null}
                fi_PRECIO_TELEFONIA_ENPS={item.fi_PRECIO_TELEFONIA_ENPS}
                fi_PRECIO_TELEVISION_ESPN={item.fi_PRECIO_TELEVISION_ESPN}
                fi_PRECIO_INTERNET_ESPS={item.fi_PRECIO_INTERNET_ESPS}
                fc_COLOR_PRECIO={item.fc_COLOR_PRECIO}
                fc_ETIQUETA_PRECIO_TACHADO={item.fc_ETIQUETA_PRECIO_TACHADO}
                fc_PRECIO_TACHADO={<NumberFormat thousandSeparator={","} decimalSeparator={"."} displayType={'text'} value={item.fc_PRECIO_TACHADO.includes(".") ? item.fc_PRECIO_TACHADO : item.fc_PRECIO_TACHADO } />}
                Discount={item?.fc_PRECIO_TACHADO > 0 && parseInt(item.fc_PRECIO_TACHADO) !== parseInt(item.fi_PRECIO_PLAN) ? <NumberFormat displayType={'text'} value={(100 - (item.fi_PRECIO_PLAN * 100) / item.fc_PRECIO_TACHADO).toFixed(0)} /> : null}
                fc_NOTA_DEBAJO_PRECIO={item.fc_NOTA_DEBAJO_PRECIO}
                fc_TEXTO_DETALLE={item.fc_TEXTO_DETALLE}
                fc_URL_DETALLE={item.fc_URL_DETALLE}
                fc_TARGET_DETALLE={item.fc_TARGET_DETALLE}
                fi_BAN_DETALLE={item.fi_BAN_DETALLE}
                fc_OPCION_CONTRATACION={item.fc_OPCION_CONTRATACION}
                fc_TEXTO_CONTRATAR={item.fc_TEXTO_CONTRATAR}
                fc_URL_CONTRATAR={item.fc_URL_CONTRATAR}
                fc_TARGET_CONTRATAR={item.fc_TARGET_CONTRATAR}
                fi_BAN_CONTRATAR={item.fi_BAN_CONTRATAR}
                fi_ORDEN={item.fi_ORDEN}
                fi_ACTIVO={item.fi_ACTIVO}
                fi_ID_DASHBOARD={item.fi_ID_DASHBOARD}
                fi_BAN_ENPN={item.fi_BAN_ENPN}
                fi_BAN_ENPS={item.fi_BAN_ENPS}
                fi_BAN_ESPN={item.fi_BAN_ESPN}
                fi_BAN_ESPS={item.fi_BAN_ESPS}
                fc_ETIQUETA_PROMOCION_ATP={item.fc_ETIQUETA_PROMOCION_ATP}
                fi_PRECIO_AHORRO={item.fi_PRECIO_AHORRO}
                fc_ETIQUETA_PERIODO={item.fc_ETIQUETA_PERIODO}
                fc_TITULO_PROMO={item.fc_TITULO_PROMO}
                Caracteristicas={item.caracteristicas}
                caracteristicasPromocion={item.caracteristicasPromocion}
                Acordeon={item.acordeon}
                lstPlanContratacionxPlan={item.lstPlanContratacionxPlan}
                keysPlanCompare={keysPlanCompare}
                fi_INCLUIR_SECCION={item.fi_INCLUIR_SECCION}
                fc_ETIQUETA_ROJA={item.fc_ETIQUETA_ROJA}
                fc_TITULO_SECCION={item.fc_TITULO_SECCION}
                fc_DESCRIPCION_SECCION={item.fc_DESCRIPCION_SECCION}
                fc_TEXTO_BOTON={item.fc_TEXTO_BOTON}
                fc_TARGET_BOTON={item.fc_TARGET_BOTON}
                fc_URL_BOTON={item.fc_URL_BOTON}
                fc_DESCRIPCION_OFERTA={item.fc_DESCRIPCION_OFERTA}
                fc_PLAN_ICONO={item.fc_PLAN_ICONO}
                fc_DETALLE_PLAN={item?.fc_DETALLE_PLAN ? item.fc_DETALLE_PLAN : ""}
                fi_SERVICIO={item.fi_SERVICIO}
                fc_FAMILIA={item.fc_FAMILIA}
            />
		</div>
    )) : null
	return (
		<>
			<section className="paquetesMiNegocio light">
				<div className="container">
					<div className="contTitlePaquetesMN">
						<h2>{ localStorage.getItem('titulo_seccion') ? localStorage.getItem('titulo_seccion') : "Planes y Precios" }</h2>
					</div>
					{PlayPLanData && <Slider {...settingsSliderPlanes} className="paquetesMiNegocioSlider">											
						{ 
						PlayPLanData
						}							 
					</Slider>	}
                    { localStorage.getItem('referencia_producto') ?
                        <div class="paquetesMiNegocioNotas">
                            {Parser(String(localStorage.getItem('referencia_producto')))}
                        </div>
                        : null
                    } 
				</div>
			</section>			
		</>
	);
}

export default PaquetesMiNegocio
